<div class="send-mail">
  <h2 class="headline">{{'PAYMENT_LINK_PAGE.MODAL_SEND_MAIL.TITLE' | translate}}</h2>

  <div class="send-mail__line">
    <div
      *ngFor="let item of mailCollection"
      class="input-line">
      <p class="input-line__name">{{'PAYMENT_LINK_PAGE.MODAL_SEND_MAIL.EMAIL' | translate}}</p>
      <label>
        <input
          [(ngModel)]="item.mail"
          class="input-line__input"
          placeholder="E-mail"
          type="email">
      </label>
    </div>
  </div>
  <button
    *ngIf="mailCollection.length < 4"
    (click)="addEmail()"
    class="btn btn-link add-mail">
    {{'PAYMENT_LINK_PAGE.MODAL_ADD.ADD_EMAIL' | translate}}
  </button>
  <div class="btn-block">
    <button
      [disabled]="StatusButton"
      (click)="sendMail()"
      class="btn btn-accent">
      {{'PAYMENT_LINK_PAGE.MODAL_SEND_MAIL.SEND' | translate}}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{'PAYMENT_LINK_PAGE.MODAL_SEND_MAIL.CANCEL' | translate}}
    </button>
  </div>
</div>


